<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col sm="12">
				<b-card>
					<vue-element-loading :active="FORM_LOADING">
						<img src="img/Spinner-1s-200px.svg">
					</vue-element-loading>
					<data-form-header
						v-bind:FORM_LOADING="FORM_LOADING"
						v-bind:FORM_MODE="FORM_MODE"
						v-bind:View_Title="view_title"
						v-on:new_clicked="onNewClicked"
						v-on:edit_clicked="onEditClicked"
						v-on:delete_clicked="onDeleteClicked"
					></data-form-header>
					<b-form id="user_form" @submit.prevent="onSubmit" novalidate>
						<!-- Username -->
						<b-form-group
							description
							label="Username"
							label-for="inputUsername"
							:invalid-feedback="invalidFeedback_username"
							:valid-feedback="validFeedback_username"
							:label-cols="2"
							:horizontal="true"
						>
							<b-form-input
								:readonly="this.FORM_MODE === 'R'"
								id="inputUsername"
								type="text"
								:state="state_username"
								v-model.trim="UserDATA.username"
							></b-form-input>
						</b-form-group>

						<!-- Password -->
						<b-form-group
							description
							label="Password"
							label-for="inputPassword"
							:invalid-feedback="invalidFeedback_password"
							:valid-feedback="validFeedback_password"
							:label-cols="2"
							:horizontal="true"
						>
							<b-form-input
								:readonly="this.FORM_MODE === 'R'"
								id="inputPassword"
								type="password"
								:state="state_password"
								v-model.trim="UserDATA.password"
							></b-form-input>
						</b-form-group>

						<!-- Confirm Password -->
						<b-form-group
							description
							label="Confirm Password"
							label-for="inputConfPwd"
							:invalid-feedback="invalidFeedback_confirmpassword"
							:valid-feedback="validFeedback_confirmpassword"
							:label-cols="2"
							:horizontal="true"
						>
							<b-form-input
								:readonly="this.FORM_MODE === 'R'"
								id="inputConfPwd"
								type="password"
								:state="state_confirmpassword"
								v-model.trim="UserDATA.confirmpassword"
							></b-form-input>
						</b-form-group>

						<!-- Member -->
						<div class="form-group row">
							<label for="inputMember" class="col-sm-2 col-form-label">Associated Member</label>
							<div class="col-sm-4">
								<b-form-select
									:disabled="this.FORM_MODE === 'R'"
									v-model="UserDATA.member_id"
									:options="memberlist"
									id="inputMember"
									:plain="true"
								/>
							</div>
						</div>
					</b-form>
					<div slot="footer">
						<b-button
							form="user_form"
							type="submit"
							variant="primary"
							:disabled="this.FORM_MODE === 'R' || this.FORM_LOADING === true"
						>
							<i class="fa fa-check fa-fw fa-lg"></i> Save
						</b-button>
						<b-button
							type="reset"
							variant="secondary"
							class="ml-2"
							:disabled="this.FORM_MODE === 'R'"
							@click="onCancel"
						>
							<i class="fa fa-ban fa-fw fa-lg"></i> Cancel
						</b-button>
					</div>
				</b-card>
			</b-col>
		</b-row>
		<b-modal
			title="Delete"
			class="modal-warning"
			okTitle="Yes"
			:noCloseOnBackdrop="true"
			v-model="DeleteWarningModal"
			@ok="onDeleteOkClicked"
			ok-variant="warning"
		>Delete this user. Are you sure?</b-modal>
	</div>
</template>
<script>
import VueAxios from "@/shared/axios-instance.js";
import VueElementLoading from "vue-element-loading";
import DataFormHeader from "@/shared/data-form-header.vue";

function UserObjectClass(data) {
	this.id = data ? data.id : 0;
	this.username = data ? data.username : "";
	this.password = data ? data.password : "";
	this.confirmpassword = data ? data.confirmpassword : "";
	this.member_id = data ? data.member_id : 0;

	this.IsEqualTo = function(equalTo) {
		let propertiesEqual = false;
		if (
			this.id === equalTo.id &&
			this.username === equalTo.username &&
			this.password === equalTo.password &&
			this.member_id === equalTo.member_id
		) {
			propertiesEqual = true;
		}
		return propertiesEqual;
	};
}

export default {
	data() {
		return {
			FORM_MODE: "", // N: New, R: readonly (view details), E: edit
			FORM_LOADING: false,
			UserDATA: {},
			OriginalUserDATA: {},
			memberlist: {},
			IsSubmitClicked: false,

			DeleteWarningModal: false
		};
	},
	components: {
		VueElementLoading,
		DataFormHeader
	},
	created() {
		this.UserDATA = new UserObjectClass();
		this.OriginalUserDATA = new UserObjectClass();
		this.$nextTick(function() {
			if (
				this.$route.params.id !== undefined &&
				this.$route.params.id > 0
			) {
				this.FORM_MODE = "R";
				this.UserDATA.id = this.$route.params.id;
				this.FORM_LOADING = true;
				this.getData();
			} else {
				this.FORM_MODE = "N";
			}
			this.getMembers();
		});
	},
	mounted: function() {},
	methods: {
		onSubmit(evt) {
			evt.preventDefault();
			this.IsSubmitClicked = true;
			if (this.FORM_STATE === true && this.Is_FormDataChanged === true) {
				// Create
				if (this.FORM_MODE === "N" && this.UserDATA.id === 0) {
					this.FORM_LOADING = true;
					VueAxios.post("/user", this.UserDATA)
						.then(resp => {
							if (resp.status === 200) {
								this.$snotify.success("New user record created", 'Success');
								this.UserDATA.id = resp.data;
								this.FORM_MODE = "R";
								this.getData();
								this.$router.push("/admin/ud/" + resp.data);
							}
						})
						.catch(err => {
							this.$snotify.error(err.data.Message, 'Error');
							//reject(err);
						});
				} else if (this.FORM_MODE === "E" && this.UserDATA.id > 0) {
					// Edit
					this.FORM_LOADING = true;
					VueAxios.put("/user", this.UserDATA)
						.then(resp => {
							if (resp.status === 200) {
								this.FORM_LOADING = false;
								this.$snotify.success("User details updated", 'Success');
								this.FORM_MODE = "R";
								this.OriginalUserDATA = new UserObjectClass(
									this.UserDATA
								);
								this.IsSubmitClicked = false;
								this.$router.push(
									"/admin/ud/" + this.UserDATA.id
								);
							}
						})
						.catch(err => {
							//reject(err);
							this.$snotify.error(err.data.Message, 'Error');
						});
				}
			} else {
				if (
					this.Is_FormDataChanged === false &&
					this.FORM_STATE === true
				) {
					this.$snotify.info("Nothing to save", '');
				}
			}
		},
		onCancel() {
			this.$router.push("/admin");
		},
		getData() {
			VueAxios.get("/user/" + this.UserDATA.id)
				.then(resp => {
					if (resp.status === 200) {
						this.UserDATA = new UserObjectClass(resp.data);
						this.OriginalUserDATA = new UserObjectClass(resp.data);
						this.FORM_LOADING = false;
						this.IsSubmitClicked = false;
					}
				})
				.catch(err => {
					//reject(err);
					this.$snotify.error(err.data.Message, 'Error');
				});
		},
		getMembers() {
			VueAxios.get(`/SelectListMembers`)
				.then(resp => {
					this.memberlist = resp.data;
				})
				.catch(err => {
					this.$snotify.error(err.data.Message, 'Error');
				});
		},
		onDeleteClicked() {
			this.DeleteWarningModal = true;
		},
		onDeleteOkClicked() {
			this.DeleteWarningModal = false;
			this.FORM_LOADING = true;
			VueAxios.delete("/user/" + this.UserDATA.id)
				.then(resp => {
					if (resp.status === 200) {
						this.FORM_LOADING = false;
						this.$snotify.success("Item deleted successfully", 'Success');
						this.$router.push("/admin");
					}
				})
				.catch(err => {
					//reject(err);
					this.$snotify.error(err.data.Message, 'Error');
				});
		},
		onEditClicked() {
			this.FORM_MODE = "E";
		},
		onNewClicked() {
			this.$router.push("/admin/newuser");
			this.UserDATA = new UserObjectClass();
			this.OriginalUserDATA = new UserObjectClass();
			this.FORM_MODE = "N";
		}
	},
	computed: {
		Is_FormDataChanged() {
			return !this.UserDATA.IsEqualTo(this.OriginalUserDATA);
		},
		view_title() {
			if (this.FORM_MODE === "N") {
				return "New User";
			} else if (this.FORM_MODE === "R") {
				return "User Details";
			} else if (this.FORM_MODE === "E") {
				return "Edit User Details";
			}
		},

		/* input states */
		state_username() {
			if (
				this.IsSubmitClicked === true ||
				this.UserDATA.username !== this.OriginalUserDATA.username
			) {
				return this.UserDATA.username.length >= 3 ? true : false;
			} else {
				return null;
			}
		},
		state_password() {
			let L = this.UserDATA.password.length;
			let M = this.FORM_MODE;

			if (this.IsSubmitClicked === true) {
				if (M === "N") {
					return L >= 3 ? true : false;
				} else if (M === "E") {
					if (L === 0) {
						return null;
					} else {
						return L > 0 && L < 3 ? false : true;
					}
				}
				return null;
			}
		},
		state_confirmpassword() {
			if (
				this.IsSubmitClicked === true &&
				(this.FORM_MODE === "N" || this.FORM_MODE === "E")
			) {
				return this.UserDATA.confirmpassword === this.UserDATA.password
					? true
					: false;
			} else {
				return null;
			}
		},

		FORM_STATE() {
			return this.state_username !== false &&
				this.state_password !== false &&
				this.state_confirmpassword !== false
				? true
				: false;
		},

		/* invalid feedbacks */
		invalidFeedback_username() {
			if (this.state_username !== false) {
				return "";
			} else {
				return "Username is required. Minimum 3 characters.";
			}
		},
		invalidFeedback_password() {
			if (this.state_password !== false) {
				return "";
			} else {
				return "Password is required. Minimum 3 characters.";
			}
		},
		invalidFeedback_confirmpassword() {
			if (this.state_confirmpassword !== false) {
				return "";
			} else {
				return '"Password" and "confirm password" do not match.';
			}
		},

		/* valid feedbacks */
		validFeedback_username() {
			return this.state_username === true ? "" : ""; // return this.state_name === true ? "Thank you" : "Bad input";
		},
		validFeedback_password() {
			return this.state_password === true ? "" : ""; // return this.state_name === true ? "Thank you" : "Bad input";
		},
		validFeedback_confirmpassword() {
			return this.state_confirmpassword === true ? "" : ""; // return this.state_name === true ? "Thank you" : "Bad input";
		}
	}
};
</script>
